import Image from "next/image";

export const HeroSplashImage = ({
  src,
  blurSrc,
  circle = true,
}: {
  src: string;
  blurSrc?: string;
  circle?: boolean;
}) => {
  return (
    <div
      className={
        "absolute left-0 top-0 h-[calc(74vh)] max-h-[800px] w-full duration-1000 animate-in fade-in gradient-mask-b-50 sm:h-[calc(82vh)] md:h-[calc(92vh)]"
      }
    >
      {/* feature img */}
      <div className="absolute left-0 top-0 h-full w-full duration-1000 animate-in fade-in gradient-mask-b-70">
        <Image
          priority={true}
          placeholder="blur"
          blurDataURL={blurSrc ?? src}
          src={src}
          draggable={false}
          fill={true}
          className={
            "object-cover duration-1000 animate-in fade-in object-[center_24%] gradient-mask-b-40"
          }
          alt={""}
        />
      </div>

      {/* gradient */}
      <div
        className="absolute h-full w-full"
        style={{
          backgroundImage: `
      linear-gradient(240deg, rgba(2, 2, 2, 0.1) 0%, rgba(2, 2, 2, 0.1) 40%), 
      linear-gradient(0deg, rgba(2, 2, 2, 0.8) 0%, rgba(2, 2, 2, 0.1) 40%), 
      linear-gradient(120deg, rgba(2, 2, 2, 0.8) 0%, rgba(2, 2, 2, 0.1) 60%), 
      linear-gradient(180deg, rgba(2, 2, 2, 0.5) 0%, rgba(2, 2, 2, 0.1) 30%),
      linear-gradient(to top, rgba(2, 2, 2, 0.6) 0%, rgba(2, 2, 2, 0.1) 50%)`,
        }}
      />
      {circle && (
        <div className="absolute h-full w-full gradient-mask-b-70 [background-image:radial-gradient(circle,_rgba(0,0,0,0.5)_40%,_rgba(0,0,0,0)_60%)]" />
      )}
    </div>
  );
};
